import { Component } from "@angular/core";
import {
  FormsModule,
  ReactiveFormsModule,
  FormBuilder,
  FormGroup,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { InputTextModule } from "primeng/inputtext";
import { PasswordModule } from "primeng/password";
import { ButtonModule } from "primeng/button";
import { CommonModule } from "@angular/common";
import { AuthService } from "../auth.service";
import { MessageService } from "primeng/api";
import { ToastModule } from "primeng/toast";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
interface SendCodeResponse {
  [key: string]: any;
}
@Component({
  selector: "app-verify-code",
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InputTextModule,
    PasswordModule,
    ButtonModule,
    ToastModule,
  ],
  templateUrl: "./verify-code.component.html",
  styleUrls: ["./verify-code.component.scss"],
  providers: [MessageService],
})
export class VerifyCodeComponent {
  private apiUrlSendCode =
    environment.apiUrlMSCommunicationService + "/mailer/send-code";
  private apiUrlValidateExpirationCode =
    environment.apiUrlMSIdentifyService + "/auth/validate-expiration-code";
  loginForm: FormGroup;
  submitted = false;
  loading = false;

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private authService: AuthService,
    private router: Router,
    private messageService: MessageService
  ) {
    this.loginForm = this.fb.group({
      code: [
        "",
        [Validators.required, Validators.minLength(4), Validators.maxLength(4)],
      ],
    });
  }

  get f() {
    return this.loginForm.controls;
  }

  onSubmit() {
    this.submitted = true;
    if (this.loginForm.invalid) return;
    const { code } = this.loginForm.value;
    const email = localStorage.getItem("emailVerify");
    // El código se valida en el servidor. Antes llegaba en la respuesta de
    // send-code y se comparaba aquí: cualquiera lo leía en la red o en
    // localStorage sin tener acceso al correo.
    this.loading = true;
    this.http
      .post<{ valid: boolean; message?: string }>(this.apiUrlValidateExpirationCode, { email, code })
      .subscribe({
        next: (response) => {
          this.loading = false;
          if (response.valid) {
            this.router.navigate(["/register-company"]); //aqui dirigir al registro
          } else {
            this.messageService.add({
              severity: "error",
              summary: "Código inválido",
              detail: response.message || "El código ingresado no es válido o ha expirado.",
            });
          }
        },
        error: () => {
          this.loading = false;
          this.messageService.add({
            severity: "error",
            summary: "Error",
            detail: "Ocurrió un error al validar el código. Intenta nuevamente.",
          });
        },
      });
  }
  //counter
  countdown: number = 0; // Valor inicial del contador
  isCountdownActive: boolean = false;

  ngOnInit() {
    this.startCountdown();
  }

  startCountdown() {
    this.isCountdownActive = true;
    this.countdown = 30; // Reiniciamos el contador

    const interval = setInterval(() => {
      this.countdown--;

      if (this.countdown <= 0) {
        clearInterval(interval);
        this.isCountdownActive = false;
      }
    }, 1000); // Actualiza cada segundo
  }
  onCodeInput(event: any) {
    const value = event.target.value;
    if (value.length > 4) {
      event.target.value = value.slice(0, 4);
    }
  }
  resendCode() {
    const email = localStorage.getItem("emailVerify");
    this.http.post<SendCodeResponse>(this.apiUrlSendCode, { email }).subscribe({
      next: (response) => {
        this.loading = false;
        this.messageService.add({
          severity: "success",
          summary: "Enviado",
          detail: "Se ha enviado un código de verificación al correo.",
        });
      },
      error: (err) => {
        this.loading = false;
        this.messageService.add({
          severity: "error",
          summary: "Error al enviar código",
          detail:
            err.error?.message ||
            "No se pudo enviar el código de verificación.",
        });
      },
    });
    this.startCountdown(); // Reinicia el contador
  }
}
